export const fieldTypes = {
  TEXT_INPUT: "textInput",
  DATE_PICKER: "datePicker",
  INTEGER_INPUT: "integerInput",
  PERCENT_INPUT: "percentInput",
  AUTOCOMPLETE_INPUT: "autocompleteInput",
  MONEY_INPUT: "moneyInput",
  DECIMAL_INPUT: "decimalInput"
};
